import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button'
import useMobileDetect from 'helpers/mobile-detect'
import PropTypes from 'prop-types'
import { smoothScrollTo } from 'helpers/scrollTo'
import { LazyBackgroundImage } from 'components/share/withImages'

import styles from './making-excuse.module.scss'

export default function MakingExcuse (props) {
  const [image, setImage] = useState('/static/images/programs/cta-block.png')
  const [textButton, setTextButton] = useState('Get Shredded')
  const [textMobileButton, setTextMobileButton] = useState('')
  const [title, setTitle] = useState(
    'Stop making excuses, start making progress'
  )
  const currentDevice = useMobileDetect()

  useEffect(() => {
    if (props.image) {
      setImage(props.image)
    }
    if (props.textButton) {
      setTextButton(props.textButton)
    }
    if (props.textMobile) {
      setTextMobileButton(props.textMobile)
    }
    if (props.title) {
      setTitle(props.title)
    }
  }, [props])

  useEffect(() => {
    if (currentDevice.isMobile() && currentDevice.width < 768) {
      setImage('/static/images/programs/bg-m-cta-block.png')
      if (props.image && props.image.includes('testimonial')) {
        setImage(props.image)
      }
      if (props.image && props.image.includes('about')) {
        setImage('/static/images/about/bg-m-excuse.png')
      }
      if (props.imageMobile && props.imageMobile.includes('testimonial')) {
        setImage(props.imageMobile)
      }
    } else {
      setImage('/static/images/programs/cta-block.png')
      if (props.image && props.image.includes('testimonial')) {
        setImage(props.image)
      }
      if (props.image && props.image.includes('about')) {
        setImage('/static/images/about/bg-excuse.png')
      }
    }
    LazyBackgroundImage({ src: image, alt: 'Placeholder', loaded: currentDevice.width > 0 })
  }, [props, currentDevice.width])

  const moveToProgram = () => {
    const element = document.getElementById('choose-program')
    if (element) {
      smoothScrollTo('#choose-program')
    }
  }

  const bgImage = 'url(' + image + ') top left/100% auto no-repeat #798087'
  return (
    <section className={styles['making-excuse']}>
      <div className={styles['making-excuse__wrapper'] + ' lazy-background'} style={{ background: bgImage }}>
        <div className='container'>
          <h5 className={styles['making-excuse__title'] + ' making-title'}>{title}</h5>
          <Button variant='danger' className='bg-red no-border  making-button' onClick={moveToProgram}>
            {textMobileButton && currentDevice.isMobile()
              ? textMobileButton
              : textButton}
          </Button>
        </div>
      </div>
    </section>
  )
}

MakingExcuse.propTypes = {
  image: PropTypes.string,
  imageMobile: PropTypes.string,
  textButton: PropTypes.string,
  textMobile: PropTypes.string,
  title: PropTypes.string
}
